/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @returns {FormReducerState}
 */
export function getFormReducerState () {
    
    return {
        form: {
            name: "",
            status: "draft",
            version: "1.1.0",
            guid: "",
            type: "",
            questions: [],
            steps: [],
            reuses: [],
        },
        isFormDirty: false,
        validationErrors: [],
        modal: "",
        count: 0,
    };
}
